/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import { getTokenFn, setTokenFn } from '@/assets/utils/util'
import getters from './getters'

const modules = {}

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: 'lawsinfo-web',
      reducer(state) {
        return {
          // 刷新不消失的state
          browserIe: state.browserIe,
          distributorOpenType: state.distributorOpenType,
          userId: state.userId,
          userInfo: state.userInfo,
          vipInfo: state.vipInfo,
          siteInfo: state.siteInfo,
          distributorId: state.distributorId
        }
      }
    })
  ],
  state: {
    refreshForToken: false, // 地址栏输入token实时刷新
    noLoading: false, // 全局拦截器不显示loading
    browserIe: false, // 判断浏览器是否为IE
    distributorOpenType: '_blank', // 判断是否开新标签，默认开新标签
    token: getTokenFn() || '', // token
    userId: '', // 用户id
    userInfo: null, // 用户信息
    vipInfo: null, // 会员信息
    siteInfo: null, // 网站信息
    distributorId: '', // 渠道id
    existExpert: false, // 是否存在专家，false为不存在，就不显示咨询按钮
    curUserData: {}
  },
  actions: {},
  mutations: {
    setbrowserIe(state, browserIe) {
      state.browserIe = browserIe
    },
    setdistributorOpenType(state, distributorOpenType) {
      state.distributorOpenType = distributorOpenType
    },
    setToken(state, token) {
      // 设置token  同步到cookie 有效期默认7天
      setTokenFn(token)
      state.token = token
    },
    setuserId(state, userId) {
      state.userId = userId
    },
    setuserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setvipInfo(state, vipInfo) {
      state.vipInfo = vipInfo
    },
    setsiteInfo(state, siteInfo) {
      state.siteInfo = siteInfo
    },
    setdistributorId(state, distributorId) {
      state.distributorId = distributorId
    },
    setexistExpert(state, existExpert) {
      state.existExpert = existExpert
    },
    setCurUserData(state, curUserData) {
      state.curUserData = curUserData
    }
  },
  modules,
  getters
})
